// src/components/AddCompanyForm/utils.js
export const toHex = (v) => {
  if (!v) return "";
  let s = String(v).trim();
  if (s.startsWith("#")) s = s.slice(1);
  if (!/^[0-9a-fA-F]{6}$/.test(s)) return "";
  return `#${s.toUpperCase()}`;
};

export const onlyDigits = (s) => String(s || "").replace(/\D+/g, "");

export const validCep8 = (s) => /^\d{8}$/.test(onlyDigits(s));

export const isHttps = (url) => /^https?:\/\//i.test(String(url || "").trim());

export const slugify = (s) =>
  String(s || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

export const uid = () => `${Date.now()}_${Math.random().toString(16).slice(2)}`;
